import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  Row,
  Col,
  Label,
  Card
} from "reactstrap";
import i18n from "../../../i18n";
import { getCostCenterReport } from "../../../helpers/api_rombo_helper";
import Select from "react-select";

const DownloadReportModal = ({ isOpen, toggle, setShowAlertSuccess, setDownloadReportModal, selectCostCenter, setTextHeader, setTextBody, token }) => {

  const [selectFileType, setSelectFileType] = useState(null);

  const downloadReport = () => {
    getCostCenterReport(token, selectCostCenter.id, selectFileType?.value)
      .then((response) => {
        var file = new File([response], `${selectCostCenter.name}.${selectFileType?.value.toLowerCase()}`); 
        const fileURL = window.URL.createObjectURL(file);
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = `${selectCostCenter.name}.${selectFileType?.value.toLowerCase()}`;
        alink.click();
        setShowAlertSuccess(true)
        setDownloadReportModal(false)
        setTextHeader(i18n.t("DownloadedReport"))
        setTextBody(i18n.t("SuccessDownloadReportMultiple", { format: selectFileType?.label }))
      })
      .catch((error) => {
        console.error("Error - getCostCenterReport - ", error)
        setErrorAlert(true)
        setErrorAlertMessage((error.response?.data?.detail || error.message))
      })
  }
  
  const handleSelectTypeFile = (select) => {
    setSelectFileType(select)
  }

  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="RequestModal"
      style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      tabIndex="-1"
      toggle={toggle}
      backdrop={'static'}
      id="staticBackdrop"
      size={"lg"}
    >
      <div>
        <p className="cancellation-title">{i18n.t("DownloadReport")}</p>
        <p className="cancellation-confirmation">{i18n.t("SelectFileType")}</p>
        <div className="separator"></div>
        <ModalBody className="mt-0 pt-0">
          <Row>
            <Form className="row gy-2 gx-3 align-items-center">
              <Col xxl={12} md={12} xs={12}>
                <div className="mb-3">
                  <Label className="cancellation-reason">{i18n.t("FileType")}</Label>
                  <p className="cancellation-text">{i18n.t("TextDownloadReport")}</p>
                  <Card>
                    <Select
                      placeholder={i18n.t("SelectFileType")}
                      onChange={(e) => {
                          handleSelectTypeFile(e);
                      }}
                      options={[{label: "XLSX", value: "XLSX"},{label: "CSV", value: "CSV"},{label: "PDF", value: "PDF"}]}
                      className="select2-selection"
                    />
                  </Card>
                </div>
              </Col>
            </Form>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn-danger"
            type="button"
            onClick={downloadReport}
          >
            {i18n.t("GenerateReport")}
          </Button>
          <Button
            className="btn-light"
            type="button"
            data-dismiss="modal"
            onClick={toggle}
          >
            {i18n.t("GoBack")}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  )
}

DownloadReportModal.propTypes = {
  setShowAlertSuccess: PropTypes.func,
  setDownloadReportModal: PropTypes.func,
  checkCostCenter: PropTypes.array,
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  setTextHeader: PropTypes.func,
  setTextBody: PropTypes.func,
  selectCostCenter: PropTypes.object
}

export default DownloadReportModal;
